import { render } from "./generic-alert.vue?vue&type=template&id=0285d4f1&ts=true"
import script from "./generic-alert.vue?vue&type=script&lang=ts"
export * from "./generic-alert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__